// Comprehensive 5-minute astrological prediction covering all 8 life domains
// With astrological symbols and domain-specific insights

export const comprehensive5MinPrediction = {
  // Main narrative - approximately 5 minutes of narration
  text: `Namaskar, aapka janm 14 May 1997 ko Dehradun mein hua. Aapki kundali ek extraordinary journey reveal karti hai jo bahut layers mein hai. 

Pehle baat karte hain aapki PERSONALITY ki. Aap naturally INTELLIGENT hain - Mercury aapke 3rd house mein strong hai jo sharp analytical mind deta hai. Aap har cheez ko logically samajhte hain. But aapka TEMPER bhi quick hai - Mars aapke 1st house mein hai jo aggressive energy deta hai. Kabhi kabhi anger control karna mushkil ho jata hai. EMOTIONAL ups and downs bhi hain - Moon afflicted hai jo mood swings aur anxiety create karta hai. Bachpan se FOCUS issues rahi hain kyunki Rahu brain ko disturb karta rehta hai.

Ab baat karte hain FAMILY aur ROOTS ki. Aapke father ek government officer hain - Sun 10th house mein hai jo father ki authority aur discipline show karta hai. Unka influence aapki life mein bahut strong raha hai. Aapki mother ek dedicated housewife hain - Moon 4th house aspect kar raha hai jo mother ki nurturing energy batata hai. Family ka emotional support hamesha mila hai lekin expectations ki pressure bhi thi.

EDUCATION aur SKILLS ki baat karein toh, aapki padhayi TECHNICAL field mein hai. 5th house mein Mercury aur Jupiter ka combination hai jo technology aur engineering ki taraf natural inclination deta hai. Aap coding, systems, machines - yeh sab easily samajh lete hain. School aapke hometown se DOOR tha jo 9th house ka effect hai - distance learning aur independence seekhna pada.

2015 mein aap ABROAD gaye - yeh 12th house ka foreign travel yoga tha combined with Rahu's influence. International exposure mila, different cultures dekhe. Wahan business opportunities explore ki jo aapki entrepreneurial spirit ko jagaaya. 2016 mein college start hua jo Jupiter dasha ka blessing tha - yeh transformative period tha. Education ke saath parallel BUSINESS bhi chalayi, multiple ventures try kiye. Success aur failures dono dekhi lekin har experience ne aapko mature banaya.

Ab main topic pe aate hain - CAREER aur PROFESSION. 10th house mein Saturn hai jo delayed success indicate karta hai but ultimate achievement guaranteed hai. 2025 tak aapko पहली STABLE job mili - Saturn dasha ka proper fruition finally aaya. Yeh job aapko financial security di aur professional identity establish hui. But aapka dil abhi bhi BUSINESS mein hai - entrepreneurial calling bahut strong hai. Technology aur business ka combination aapke liye perfect hai. 

WEALTH aur FINANCES dekhen toh, 2nd house mein Venus weak hai jo earning mein struggles dikhata hai initially. Lekin 11th house mein Jupiter strong hai jo long-term mein prosperity guarantee karta hai. Aapki wealth slowly but steadily badhegi. Multiple income sources banenge. Real estate mein investments good rahengi. 2027 ke baad Jupiter transit aapko financial breakthrough dega. Business ventures successful honge. Technology sector mein opportunities aayengi jo life-changing hongi.

Ab RELATIONSHIPS aur LOVE LIFE ki baat karein. 7th house mein Rahu hai jo complicated relationships indicate karta hai. Aapko ideal partner dhundhne mein time lagega. Initial relationships mein misunderstandings hogi. Emotional connection banana mushkil hoga kyunki Venus afflicted hai. But 2026 ke baad scenario badlega. Mature partner milega jo aapko samjhega. Marriage yoga strong hai 28-29 age ke beech. Partner supportive hogi aur career-oriented bhi. Long-distance relationship ki possibility hai pehle. Communication key hogi relationship success ke liye.

HEALTH ke baare mein important baat hai. 6th house mein Mars hai jo inflammation aur accidents ka risk deta hai. Anger se related health issues ho sakte hain - high BP, headaches, stress. Pitta dosha imbalanced hai aapme. Regular exercise zaruri hai. Yoga aur meditation daily karna chahiye. Diet mein spicy food kam karo. 2024-2025 mein digestive issues aa sakte hain - pet ki safai rakho. Mental health bhi important hai - anxiety aur overthinking kam karo. Sleep schedule proper rakho kyunki insomnia ki tendency hai. 30 ke baad health ko priority do varna complications badhenge.

SPIRITUAL GROWTH aur INNER DEVELOPMENT ki journey dekhen. 12th house mein Jupiter hai jo spiritual inclination strong dikhata hai. Aap naturally philosophy, psychology, deeper meanings mein interested hain. Saturn ki dasha spiritual awakening degi. Meditation aur mindfulness practice se bahut growth hoga. Past life karma clear karne ka time hai. Service karna aapke liye beneficial hoga - charity ya teaching. Isolation periods mein self-discovery hogi. 2026-2028 spiritual transformation ka phase hoga - life purpose clear dikhega.

Ab FRIENDSHIPS aur SOCIAL CIRCLE. 11th house strong hai jo achhe dost banaye honge. But quality over quantity wala scene hai. Fake friends bhi mile honge. Technology ke through networking badhi hogi - online communities, professional groups. Foreign friends banenge. Social media influence badhega. Community work karne se khushi milegi. 2025 ke baad influential logo se connection banega jo career boost dega.

CREATIVITY aur HOBBIES dekhen toh 5th house mein Ketu hai jo unique creative talents deta hai. Music, art, writing - kisi bhi creative field mein interest ho sakta hai. But recognition late milega. Passion projects continue rakho. Side hustle creative field mein kar sakte ho. Children के साथ अच्छा connection hoga future mein. Teaching ya mentoring bhi kar sakte ho.

HOME aur PROPERTY matters dekhen. 4th house mein Sun hai jo property ownership ka yoga hai. Apna ghar zarur hoga but 30 ke baad. Real estate mein investment profitable rahega. Ancestral property ka bhi benefit mil sakta hai. Mother ki property aapko milegi. Home environment peaceful rakhna important hai - vastu ka dhyan rakho.

Overall aapki life journey challenging rahi hai but transformation powerful hai. Early struggles ne aapko strong warrior banaya hai. Saturn ka discipline, Jupiter ki wisdom, Mars ki courage - sab qualities aapme hain. Coming years bahut promising hain. 2025-2030 golden period rahega. Success, prosperity, spiritual growth - sab aayega. Leadership qualities emerge karengi. Aap ek successful entrepreneur banoge aur logo ko inspire karoge. Bas patience rakho, consistent raho, aur apne dharma ko follow karo. Universe aapko support kar raha hai. Shubh ho aapka bhavishya!`,

  // Domain-specific keywords with house symbols
  domainIcons: [
    { 
      keyword: 'PERSONALITY', 
      house: 1, 
      symbol: '🔱', 
      planet: 'mars',
      color: '#DC143C',
      description: 'Self & Identity'
    },
    { 
      keyword: 'FAMILY', 
      house: 4, 
      symbol: '🏡', 
      planet: 'moon',
      color: '#C8C8FF',
      description: 'Home & Roots'
    },
    { 
      keyword: 'EDUCATION', 
      house: 5, 
      symbol: '📚', 
      planet: 'mercury',
      color: '#A9A9A9',
      description: 'Learning & Skills'
    },
    { 
      keyword: 'CAREER', 
      house: 10, 
      symbol: '💼', 
      planet: 'saturn',
      color: '#8B4513',
      description: 'Profession & Status'
    },
    { 
      keyword: 'WEALTH', 
      house: 2, 
      symbol: '💰', 
      planet: 'jupiter',
      color: '#FFA500',
      description: 'Money & Resources'
    },
    { 
      keyword: 'RELATIONSHIPS', 
      house: 7, 
      symbol: '💕', 
      planet: 'venus',
      color: '#FF69B4',
      description: 'Love & Partnership'
    },
    { 
      keyword: 'HEALTH', 
      house: 6, 
      symbol: '⚕️', 
      planet: 'mars',
      color: '#00CED1',
      description: 'Wellness & Vitality'
    },
    { 
      keyword: 'SPIRITUAL', 
      house: 12, 
      symbol: '🕉️', 
      planet: 'jupiter',
      color: '#9370DB',
      description: 'Inner Growth'
    }
  ],

  // Planetary keywords for icon triggers
  planetaryKeywords: [
    { keyword: 'INTELLIGENT', symbol: '☿', planet: 'mercury', color: '#A9A9A9' },
    { keyword: 'TEMPER', symbol: '♂', planet: 'mars', color: '#DC143C' },
    { keyword: 'EMOTIONAL', symbol: '☽', planet: 'moon', color: '#C8C8FF' },
    { keyword: 'prosperity', symbol: '♃', planet: 'jupiter', color: '#FFA500' },
    { keyword: 'STABLE', symbol: '♄', planet: 'saturn', color: '#8B4513' },
    { keyword: 'ABROAD', symbol: '☊', planet: 'rahu', color: '#4B0082' },
    { keyword: 'LOVE', symbol: '♀', planet: 'venus', color: '#FF69B4' },
    { keyword: 'discipline', symbol: '☉', planet: 'sun', color: '#FFD700' }
  ],

  // Enhanced timeline with domain associations
  timeline: [
    { 
      year: '1997', 
      event: 'जन्म | Birth in Dehradun',
      domain: 'Birth',
      highlight: true,
      icon: '⭐',
      color: '#edc161'
    },
    { 
      year: '2002-2012', 
      event: 'बचपन | Childhood - Family foundation, Early challenges',
      domain: 'Family',
      icon: '🏡',
      color: '#C8C8FF'
    },
    { 
      year: '2012-2015', 
      event: 'शिक्षा | Education - School away from home',
      domain: 'Education',
      icon: '📚',
      color: '#A9A9A9'
    },
    { 
      year: '2015', 
      event: 'विदेश | Foreign travel - Business exploration',
      domain: 'Growth',
      highlight: true,
      icon: '✈️',
      color: '#4B0082'
    },
    { 
      year: '2016', 
      event: 'कॉलेज | College - Technical education begins',
      domain: 'Education',
      icon: '🎓',
      color: '#A9A9A9'
    },
    { 
      year: '2016-2024', 
      event: 'उद्यम | Business ventures - Multiple projects',
      domain: 'Career',
      icon: '💼',
      color: '#8B4513'
    },
    { 
      year: '2025', 
      event: 'नौकरी | First stable job - Financial security',
      domain: 'Career',
      highlight: true,
      icon: '🎯',
      color: '#edc161'
    },
    { 
      year: '2025-2027', 
      event: 'धन | Wealth growth - Multiple income streams',
      domain: 'Wealth',
      icon: '💰',
      color: '#FFA500'
    },
    { 
      year: '2026', 
      event: 'प्रेम | Relationship begins - Mature partner',
      domain: 'Love',
      icon: '💕',
      color: '#FF69B4'
    },
    { 
      year: '2026-2028', 
      event: 'आध्यात्मिक | Spiritual awakening - Inner transformation',
      domain: 'Spiritual',
      highlight: true,
      icon: '🕉️',
      color: '#9370DB'
    },
    { 
      year: '2027+', 
      event: 'सफलता | Business success - Jupiter transit',
      domain: 'Career',
      highlight: true,
      icon: '🚀',
      color: '#edc161'
    },
    { 
      year: '2030+', 
      event: 'समृद्धि | Prosperity & Leadership - Golden period',
      domain: 'Success',
      highlight: true,
      icon: '👑',
      color: '#FFD700'
    }
  ]
};

export default comprehensive5MinPrediction;
